import Toolbar from './toolbar'
Toolbar.install = (Vue) => {
  Vue.component(Toolbar.name, Toolbar)
}

export default Toolbar


// WEBPACK FOOTER //
// ./src/components/toolbar/index.js